// extracted by mini-css-extract-plugin
export default {"period":"CollectiveInvoices_period__jZT5b"};